export { default } from 'features/reward/routes/activate-challenge-route';
